import {OfferType} from "../types/OfferType";

interface IPropertyNoun {
    nominative: string;
    genitive: string;
    locative: string;
    // agrees with the nominative: "mieszkanie jest zarezerwowane", "dom jest zarezerwowany"
    reservedParticiple: string;
}

export const getPropertyNoun = (offerType: OfferType | null): IPropertyNoun => {
    switch (offerType) {
        case OfferType.HOUSE:
        case OfferType.MODULAR_HOUSE:
            return {nominative: "dom", genitive: "domu", locative: "domu", reservedParticiple: "zarezerwowany"};
        case OfferType.COMMERCIAL:
            return {nominative: "lokal użytkowy", genitive: "lokalu użytkowego", locative: "lokalu użytkowym", reservedParticiple: "zarezerwowany"};
        default:
            return {nominative: "mieszkanie", genitive: "mieszkania", locative: "mieszkaniu", reservedParticiple: "zarezerwowane"};
    }
};
import {OfferType} from "../types/OfferType";

interface IPropertyNoun {
    nominative: string;
    genitive: string;
    locative: string;
    // agrees with the nominative: "mieszkanie jest zarezerwowane", "dom jest zarezerwowany"
    reservedParticiple: string;
}

export const getPropertyNoun = (offerType: OfferType | null): IPropertyNoun => {
    switch (offerType) {
        case OfferType.HOUSE:
        case OfferType.MODULAR_HOUSE:
            return {nominative: "dom", genitive: "domu", locative: "domu", reservedParticiple: "zarezerwowany"};
        case OfferType.COMMERCIAL:
            return {nominative: "lokal użytkowy", genitive: "lokalu użytkowego", locative: "lokalu użytkowym", reservedParticiple: "zarezerwowany"};
        default:
            return {nominative: "mieszkanie", genitive: "mieszkania", locative: "mieszkaniu", reservedParticiple: "zarezerwowane"};
    }
};
